import type { SVGProps } from "react";

export const Share04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.01478 2.66767C9.06023 3.07938 8.76338 3.45002 8.3517 3.49552C5.34157 3.82822 3 6.381 3 9.47937C3 12.8044 5.6959 15.5001 9.02168 15.5001C12.1152 15.5001 14.6646 13.1672 15.0048 10.1656C15.0514 9.75402 15.4229 9.45823 15.8344 9.5048C16.246 9.55145 16.5419 9.92293 16.4952 10.3345C16.0701 14.0859 12.8867 17.0001 9.02168 17.0001C4.86768 17.0001 1.5 13.633 1.5 9.47937C1.5 5.60771 4.42538 2.42035 8.18692 2.0046C8.5986 1.9591 8.96925 2.25597 9.01478 2.66767Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7061 2.7767C15.1823 3.18193 15.8322 3.75662 16.1915 4.18236C16.39 4.41756 16.5123 4.71976 16.4986 5.05114C16.4864 5.34582 16.3685 5.61025 16.1914 5.82012C15.832 6.24561 15.1824 6.82021 14.7063 7.22553C14.5733 7.33872 14.4074 7.48271 14.2547 7.5774C14.1044 7.67061 13.738 7.86091 13.3157 7.66583C12.8911 7.46966 12.8 7.06346 12.7742 6.89083C12.7493 6.72453 12.7495 6.52105 12.7496 6.35073C12.7498 6.16203 12.7496 5.97333 12.7496 5.78463C12.3974 5.7962 12.0846 5.81489 11.8023 5.84461C11.042 5.92467 10.592 6.07782 10.2487 6.32463C9.98677 6.51286 9.75697 6.7421 9.56805 7.0035C9.3204 7.34625 9.16612 7.79583 9.08415 8.5559C9.00067 9.3299 8.99962 10.3333 8.99962 11.7511C8.99962 12.1653 8.66385 12.5011 8.24963 12.5011C7.8354 12.5011 7.49963 12.1653 7.49963 11.7511C7.49962 10.6347 7.47285 9.5069 7.59277 8.3951C7.6884 7.50812 7.8894 6.76547 8.3523 6.12494C8.63565 5.73283 8.98035 5.38898 9.3732 5.10662C10.0149 4.64538 10.758 4.44627 11.6453 4.35285C11.9793 4.31769 12.3463 4.29652 12.7496 4.28399C12.7496 4.0732 12.7498 3.86241 12.7496 3.65163C12.7495 3.48135 12.7493 3.27792 12.7742 3.11163C12.8 2.93898 12.8911 2.53287 13.3156 2.3367C13.7378 2.14161 14.1043 2.33178 14.2546 2.42498C14.4072 2.51964 14.5731 2.66357 14.7061 2.7767Z"
      fill="white"
    />
  </svg>
);
